import { render } from "./RatingLabels.vue?vue&type=template&id=683db938&scoped=true"
import script from "./RatingLabels.vue?vue&type=script&lang=js"
export * from "./RatingLabels.vue?vue&type=script&lang=js"

import "./RatingLabels.vue?vue&type=style&index=0&id=683db938&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683db938"]])

export default __exports__